var React = require('react');

function PinInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"circle-1","cx":"11.6994","cy":"11.6276","r":"5.82149","fill":"white","strokeOpacity":"0","key":0}),React.createElement("circle",{"id":"circle-2","cx":"11.6994","cy":"11.6276","r":"8.23018","stroke":"white","strokeOpacity":"0","key":1}),React.createElement("circle",{"id":"circle-3","cx":"11.6994","cy":"11.6276","r":"11.0466","stroke":"white","strokeOpacity":"0","key":2})]);
}

PinInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = PinInline;

PinInline.default = PinInline;
